import { render, staticRenderFns } from "./IMOClassButton.vue?vue&type=template&id=6b2c0193"
import script from "./IMOClassButton.vue?vue&type=script&lang=js"
export * from "./IMOClassButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports